import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const TicketActiveFilter = ({ onChangeFilter, options }) => (
  <ReactSelect
    isSearchable={false}
    isClearable
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 1000 }) }}
    onChange={option => onChangeFilter(option ? option.value : null)}
    menuPosition="fixed"
    menuPlacement="bottom"
    placeholder="Selecciona ..."
    options={options}
  />
);

TicketActiveFilter.propTypes = {
  onChangeFilter: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default TicketActiveFilter;
